enum AnnotationInfoType {
  SOUND = "Sound",
  IMAGE = "Image",
}

export default AnnotationInfoType;
